import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/utils';

interface VerifiedAvatarProps extends React.ComponentPropsWithoutRef<typeof Avatar> {
  src?: string;
  alt?: string;
  fallback?: React.ReactNode;
  isVerified?: boolean;
}

export const VerifiedAvatar = React.forwardRef<
  React.ElementRef<typeof Avatar>,
  VerifiedAvatarProps
>(({ className, src, alt, fallback, isVerified = false, ...props }, ref) => {
  return (
    <div className="relative inline-block">
      <Avatar ref={ref} className={cn(className)} {...props}>
        <AvatarImage src={src} alt={alt} />
        <AvatarFallback>{fallback}</AvatarFallback>
      </Avatar>
      {isVerified && (
        <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-1 border border-gray-300 shadow-sm">
          <ShieldCheck className="h-3 w-3 text-blue-600" />
        </div>
      )}
    </div>
  );
});

VerifiedAvatar.displayName = "VerifiedAvatar";